import { Chip } from '@mui/material';
import React from 'react';

const AchievementChip = ({
    achievementType,
    getAchievementColors,
    size = "small",
    disabled = false,
    sx = {}
}) => {
    const difficultyColors = getAchievementColors ? getAchievementColors(achievementType) : null;

    return (
        <Chip
            size={size}
            label={achievementType}
            disabled={disabled}
            sx={{
                height: size === "small" ? '20px' : '24px',
                fontSize: size === "small" ? '11px' : '12px',
                fontWeight: 300,
                bgcolor: difficultyColors ? difficultyColors.bgcolor : '#e0e0e0',
                color: difficultyColors ? difficultyColors.color : '#333',
                '& .MuiChip-label': {
                    color: difficultyColors ? difficultyColors.color : '#333',
                    padding: size === "small" ? '0 6px' : '0 8px',
                },
                ...sx
            }}
        />
    );
};

export default AchievementChip; 